module.exports = false;



//////////////////
// WEBPACK FOOTER
// C:/thinkbit/conference/hosting/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 18